import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SalesOpportunity } from '../models/sales-opportunity-model';
import { environment } from '../../environments/environment'; // adjust if needed

@Injectable({ providedIn: 'root' })
export class SalesOpportunityService {
  private http = inject(HttpClient);
  private baseUrl = `${environment.dataApiBase}/opportunities`;

  getAllOpportunities(): Observable<SalesOpportunity[]> {
    return this.http.get<SalesOpportunity[]>(`${this.baseUrl}/all`);
  }
}
